<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <DatePicker
          type="date"
          placement="bottom"
          placeholder="选择日期"
          style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>
        <i-input
          prefix="ios-search"
          placeholder="请输入主题关键字"
          v-model="search.theme"
          style="width: auto;margin-left: 1em"
        />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <!-- 文件上传 -->
        <div class="formItem">
          <div class="formTitle">电子稿：</div>
          <div class="button" @click="toDetails" v-show="disabled">点击查看附件</div>
          <el-upload
            class="upload-demo"
            :action="api"
            :on-preview="handlePreview"
            :on-success="textSuccess"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :with-credentials="true"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="formValidate.fileList"
            :disabled="disabled"
          >
            <el-button size="small" v-show="!disabled" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
        <FormItem prop="theme" :label-width="0" style="font-size:40px">
          <div class="formItem">
            <div class="formTitle">主题:</div>
            <i-input v-model="formValidate.theme" placeholder="请输入主题" :disabled="disabled"></i-input>
          </div>
        </FormItem>
        <!-- 输入框 -->
        <FormItem prop="content" :label-width="0">
          <div class="formItem">
            <div class="formTitle">文字：</div>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              :disabled="disabled"
              v-model="formValidate.content"
            ></el-input>
          </div>
        </FormItem>

        <!-- 图片上传 -->
        <div class="formItem">
          <div class="formTitle">图片（限1张）：</div>
          <el-upload
            :action="api"
            list-type="picture-card"
            :on-success="upImgSuccess"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :file-list="formValidate.picList"
            :with-credentials="true"
            :disabled="disabled"
            :limit="1"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </Form>
      <div slot="footer">
        <i-button type="primary" v-show="!disabled" @click="activeData">{{ modal.title }}</i-button>
        <i-button
          style="margin-left: 1em;"
          @click="modal.show = false,formValidate.picList=[],formValidate.fileList=[]"
        >取消</i-button>
      </div>
    </Modal>
    <!--查看图片 -->
    <Modal :title="modal.title" v-model="modal.imgshow" :mask-closable="false" width="50%">
      <img width="100%" :src="dialogImageUrl" alt />
      <div slot="footer"></div>
    </Modal>
    <!-- 告警规则 -->
    <WarnRule ref="warnRule"></WarnRule>
    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
.formItem {
  margin: -5px 0 10px;
  .button {
    width: 80px;
    height: 35px;
    background: #409eff;
    border: 1px solid #409eff;
    border-radius: 4px;
    text-align: center;
    line-height: 35px;
    color: #fff;
    margin-bottom: -20px;
  }
  .formTitle {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
.ivu-form-item-content {
  margin-left: 0;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";
import WarnRule from "../warnBind.vue";
import { BaseUrl } from "../../../http/config";
export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "上传人员",
            key: "userName",
            align: "center"
          },
          {
            title: "上传时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h("span", {}, timeStamp(params.row.createDate));
            }
          },
          {
            title: "主题",
            key: "theme",
            align: "center"
          },
          {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "详情";
                        this.modal.show = true;
                        this.disabled = true;
                        if (params.row.picUrl && params.row.fileUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            picUrl: params.row.picUrl,
                            picList: [{ url: params.row.picUrl }],
                            fileUrl: params.row.fileUrl,
                            fileList: [
                              { name: params.row.fileUrl.split("_")[3] }
                            ]
                          };
                        } else if (params.row.picUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            picUrl: params.row.picUrl,
                            picList: [{ url: params.row.picUrl }]
                          };
                        } else if (params.row.fileUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            fileUrl: params.row.fileUrl,
                            fileList: [
                              { name: params.row.fileUrl.split("_")[3] }
                            ]
                          };
                        } else {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content
                          };
                        }
                      }
                    }
                  },
                  "详情"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.disabled = false;
                        if (params.row.maintenanceDate) {
                          // 如果有上次维保日期，n那么开启维保
                          this.MaintenanceFlag = true;
                        } else {
                          this.MaintenanceFlag = false;
                        }
                        // this.writeImg(params.row.mn); // 切换站点图片
                        if (params.row.picUrl && params.row.fileUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            picUrl: params.row.picUrl,
                            picList: [{ url: params.row.picUrl }],
                            fileUrl: params.row.fileUrl,
                            fileList: [
                              { name: params.row.fileUrl.split("_")[3] }
                            ]
                          };
                        } else if (params.row.picUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            picUrl: params.row.picUrl,
                            picList: [{ url: params.row.picUrl }]
                          };
                        } else if (params.row.fileUrl) {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content,
                            fileUrl: params.row.fileUrl,
                            fileList: [
                              { name: params.row.fileUrl.split("_")[3] }
                            ]
                          };
                        } else {
                          this.formValidate = {
                            id: params.row.id,
                            theme: params.row.theme,
                            content: params.row.content
                          };
                        }
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      //文件地址
      api: BaseUrl + "/api/upload?dir=newSite",
      //是否可编辑
      disabled: false,
      // 查询
      search: {
        name: null, // 设备名
        mn: null // 站点编号
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        imgshow: false, //图片modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        content: "",
        theme: "",
        picUrl: "",
        picList: [],
        fileUrl: "",
        fileList: []
      },
      dialogImageUrl: "",
      dialogVisible: false,
      // 验证
      ruleValidate: {
        theme: [{ required: true, message: "不能为空", trigger: "blur" }],
        content: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      siteList: [], //站点枚举
      deviceTypeList: [], // 设备类型枚举
      // 维保周期枚举
      MaintenanceList: [
        {
          date: "5天",
          type: "5天"
        },
        {
          date: "15天",
          type: "15天"
        },
        {
          date: "一个月",
          type: "1月"
        },
        {
          date: "两个月",
          type: "2月"
        },
        {
          date: "三个月",
          type: "3月"
        },
        {
          date: "半年",
          type: "6月"
        }
      ],
      // 是否启用维保字段
      MaintenanceFlag: false,
      // 站点图片
      siteImgUrl: null
    };
  },
  components: {
    toolbar,
    LoadImg,
    WarnRule
  },
  created() {
    this.getData(); // 数据初始化
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.disabled = false;
      this.formValidate = {
        theme: "",
        content: "",
        picUrl: "",
        picList: [],
        fileUrl: "",
        fileList: []
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      //console.log(this.search);
      this.$api.Info.getOtherList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Info.postDelOther({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;

          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Info.postAddOther({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Info.postEditOther({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    openMaintenance(flag) {
      this.formValidate.maintenanceTimeExpression = "";
      this.formValidate.maintenanceDate = "";
      this.MaintenanceFlag = flag;
    },

    openSiteImg() {
      this.modal.companyShow = true;
    },

    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      // this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },

    //图片移除时
    handleRemove() {
      this.formValidate.picUrl = [];
    },
    //上传超出限制事
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //图片移除时
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //图片上传
    upImgSuccess(res) {
      //console.log(res);
      if (!res.code) {
        this.formValidate.picUrl = res;
      } else {
        this.formValidate.picList = [];
        this.$Notice.warning({
          title: "上传失败",
          desc: res.message
        });
      }
    },
    //点击图片时
    handlePictureCardPreview(file) {
      this.modal.title = "详情";
      this.dialogImageUrl = file.url;
      this.modal.imgshow = true;
    },
    //文件上传成功回调
    textSuccess(res) {
      if (!res.code) {
        this.formValidate.fileUrl = res;
      } else {
        this.formValidate.fileList = [];
        this.$Notice.warning({
          title: "上传失败",
          desc: res.message
        });
      }
    },
    //点击文件列表
    handlePreview(file) {
      window.open(this.formValidate.fileUrl);
    },
    //文件超出限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 文件删除时
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //查看文件
    toDetails() {
      window.open(this.formValidate.fileUrl);
    }
  }
};
</script>